import { memo } from 'react'
import { useSelector } from 'react-redux'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import CurvedArrowIcon from 'assets/svgr-icons/CurvedArrow.svg'
import * as Styled from './styled'
import Text from 'common-components/Text'
import VideoIllustration from 'assets/svgr-icons/Illustration_Video.svg'
import { useResponsive } from 'hooks/useResponsive'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { ASPECT_RATIO_PER_TYPE } from 'containers/SubSidebar/AiImageContent/consts'

const BlankCanvas: React.FC = () => {
  const isMobile = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)
  const { aspectRatioString } = useSelector(
    projectDataSelectors.defaultDimensions
  )
  const isPortrait = aspectRatioString === ASPECT_RATIO_PER_TYPE.portrait

  return (
    <Styled.Container>
      <Styled.IllustrationWrapper $isPortrait={isPortrait}>
        <VideoIllustration />
      </Styled.IllustrationWrapper>
      <Text
        type={isMobile || isPortrait ? 'h3' : 'h1'}
        color="secondaryDark"
        align="center"
        fontWeight="600"
      >
        {translate(T.WELCOME_CANVAS_TITLE)}
      </Text>
      {!isMobile && !isPortrait && (
        <Text type="subtitle" color="secondary" align="center" fontWeight="400">
          {translate(T.WELCOME_CANVAS_SUBTITLE)}
        </Text>
      )}
      {!isMobile && (
        <Styled.ArrowWrapper $isPortrait={isPortrait}>
          <CurvedArrowIcon />
        </Styled.ArrowWrapper>
      )}
    </Styled.Container>
  )
}

export default memo(BlankCanvas)
